module.exports = __webpack_public_path__ + "static/img/full1.9d2f25ed.svg";